// RightSidebar.js

import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faBell, faUsers, faChartBar, faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const RightSidebar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    // Initial check on component mount
    handleResize();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const sidebarStyle = {
    background: "linear-gradient(180deg, #1E1A78 0%, #3A0CA3 100%)",
    color: "#FFFFFF",
    height: "100vh",
    width: isMobile ? (sidebarOpen ? "250px" : "0") : "250px",
    position: "fixed",
    top: "0",
    right: isMobile ? (sidebarOpen ? "0" : "-250px") : "0",
    paddingTop: "60px",
    transition: "width 0.3s ease-in-out, right 0.3s ease-in-out",
    overflowX: "hidden",
  };

  const headerStyle = {
    textAlign: "center",
    padding: "20px",
  };

  const navStyle = {
    listStyle: "none",
    padding: "0",
    margin: "0",
  };

  const itemStyle = {
    marginBottom: "10px",
  };

  const linkStyle = {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "#FFFFFF",
    padding: "12px 20px",
    transition: "all 0.3s ease-in-out",
    borderLeft: "4px solid transparent",
    borderRadius: "4px",
    marginBottom: "4px",
    fontWeight: "400",
  };

  const linkHoverStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderLeft: "4px solid #60A5FA",
  };
  
  const linkActiveStyle = {
    backgroundColor: "#5E17EB",
    borderLeft: "4px solid #60A5FA",
    fontWeight: "700",
  };

  const iconTextStyle = {
    marginLeft: "10px",
  };

  return (
    <div style={sidebarStyle}>
      {isMobile && (
        <div style={{ textAlign: "right", marginRight: "10px", marginBottom: "10px" }}>
          <FontAwesomeIcon icon={sidebarOpen ? faTimes : faBars} onClick={toggleSidebar} style={{ cursor: "pointer", fontSize: "20px" }} />
        </div>
      )}
      <div style={headerStyle}>
        <h3>Right Sidebar</h3>
      </div>
      <ul style={navStyle}>
        <li style={itemStyle}>
          <a 
            href="#" 
            style={linkStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, linkHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderLeft = "4px solid transparent";
            }}
          >
            <FontAwesomeIcon icon={faCog} style={{ marginRight: "12px", minWidth: "24px", color: "#FFFFFF" }} />
            <span style={iconTextStyle}>Settings</span>
          </a>
        </li>
        <li style={itemStyle}>
          <a 
            href="#" 
            style={linkStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, linkHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderLeft = "4px solid transparent";
            }}
          >
            <FontAwesomeIcon icon={faBell} style={{ marginRight: "12px", minWidth: "24px", color: "#FFFFFF" }} />
            <span style={iconTextStyle}>Notifications</span>
          </a>
        </li>
        <li style={itemStyle}>
          <a 
            href="#" 
            style={linkStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, linkHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderLeft = "4px solid transparent";
            }}
          >
            <FontAwesomeIcon icon={faUsers} style={{ marginRight: "12px", minWidth: "24px", color: "#FFFFFF" }} />
            <span style={iconTextStyle}>Users</span>
          </a>
        </li>
        <li style={itemStyle}>
          <a 
            href="#" 
            style={linkStyle}
            onMouseEnter={(e) => {
              Object.assign(e.currentTarget.style, linkHoverStyle);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderLeft = "4px solid transparent";
            }}
          >
            <FontAwesomeIcon icon={faChartBar} style={{ marginRight: "12px", minWidth: "24px", color: "#FFFFFF" }} />
            <span style={iconTextStyle}>Analytics</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default RightSidebar;
